import { GLOBAL_HEADER_HEIGHT } from "@/constants/styles/header";
import {
	Loader,
	type MantineLoader,
	type MantineSize,
	Stack,
	Text,
} from "@mantine/core";

type Props = {
	height?: string;
	size?: MantineSize;
	type?: MantineLoader;
	message?: string;
};

export const Loading = ({
	height = `calc(100vh - ${GLOBAL_HEADER_HEIGHT}px)`,
	size = "md",
	type = "bars",
	message,
}: Props) => {
	return (
		<Stack justify="center" align="center" h={height}>
			<Loader type={type} size={size} />
			{message && <Text>{message}</Text>}
		</Stack>
	);
};
